/**
 * dog-drawer-mobile-header.js
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import MobileDrawerAppBar from 'components/menu-drawer/mobile/mobile-drawer-app-bar';


export default function DogDrawerMobileHeader(props) {
  const { dogId } = useParams();

  return (
    <MobileDrawerAppBar
      {...props}
      basePath={`${props.basePath}/${dogId}/edit`}
      hideMenu={!dogId}
      items={[
        {
          key: 'details',
          label: 'Details',
          iconName: 'edit',
          path: '/details'
        },
        {
          key: 'photo',
          label: 'Photo',
          iconName: 'photo',
          path: '/photo'
        },
        {
          key: 'documents',
          label: 'Uploaded Documents',
          iconName: 'user-guide',
          path: '/docs'
        },
      ]}
    />
  )
};